module.exports = __webpack_public_path__ + "d5eb7925c4ae2c7a0a6fa62c3608e23d.svg";